






























import { Component, Vue, Emit, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import BackofficeAutorizacaoStore from '@/components/Backoffice/Store/BackofficeAutorizacaoStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import { TipoOrigemEnum, RequestMessage, TipoUsuarioEnum, Solicitacao, SituacaoEnum } from '@/types/_'
import { timeoutDefault } from '@/utils/common'
import EventBus from '@/plugins/EventBus'

@Component

export default class ModalSolicitacaoCancelamentoGeral extends Vue {
  @Prop({ required: true }) tipoUsuario: TipoUsuarioEnum

  loadCancelar: boolean = false
  loadVoltar: boolean = false

  get loadingCancelar() {
    return this.loadCancelar
  }

  set loadingCancelar(val: boolean) {
    this.loadCancelar = val
  }

  get loadingVoltar() {
    return this.loadCancelar
  }

  set loadingVoltar(val: boolean) {
    this.loadVoltar = val
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getBackofficeAgendamentoStore() {
    return getModule(BackofficeAgendamentoStore, this.$store)
  }

  get getBackofficeAutorizacaoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }

  get showModal() {
    return this.getSolicitacaoCancelamentoStore.modal.cancelamentoGeral
  }

  set showModal(value: boolean) {
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoGeral(value)
  }

  get getDisabledAutocomplete() {
    return this.getSolicitacaoCancelamentoStore.cancelarSolicitacaoParam.situacao.key === SituacaoEnum.CancelamentoSolicitado
  }

  async cancelamentoSolicitado() {
    if (this.isValid()) {
      this.loadingCancelar = true
      const response = await this.getSolicitacaoCancelamentoStore.cancelarSolicitacao()
      if (response.success) {
        const store: string = this.$route.name === 'BackofficeAgendamento' ? 'getBackofficeAgendamentoStore' : 'getBackofficeAutorizacaoStore'
        await this[store].loadAgendamentosMedicoSearch()
        this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema no cancelamento da solicitação.', icon: 'warning', color: '#C62828' })
      }
      this.loadingCancelar = false
    }
  }

  isValid() {
    let valid: boolean = true
    if (['', null, undefined].includes(this.getSolicitacaoCancelamentoStore.motivo)) {
      valid = false
      this.getSolicitacaoCancelamentoStore.setMotivoMessage('Por favor informe o motivo.')
    } else {
      this.getSolicitacaoCancelamentoStore.setMotivoMessage('')
    }

    return valid
  }

  async voltar() {
    this.loadingVoltar = true
    await timeoutDefault()
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoGeral(false)
    this.getSolicitacaoCancelamentoStore.clear()
    this.loadingVoltar = false
  }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  @Emit('clearLoadingRequest')
  clearLoadingRequest() { }

  @Emit('closeModal')
  async closeModal() {
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoGeral(false)
    this.getSolicitacaoCancelamentoStore.clear()
  }
}

